module.exports = __webpack_public_path__ + "static/media/peopleGroup3.4559b486.jpg";